import { SimpleOrder } from '@model/simpleOrder';
import { AuthServer } from '@services/auth-server.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { Quote } from '@model/webFeeder/quote.model';
import { ConfigService } from '@services/webFeeder/config.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { Constants } from '@utils/constants';
import { Subscription , of } from 'rxjs';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { WorkspaceNewDto } from '@dto/workspacenew.dto';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';

@Component({
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',

})
export class EditOrderComponent implements OnInit, OnDestroy {

  @Input() dataOrder: any;
  @Output() close = new EventEmitter<any>();
  @Output() editOpenChange = new EventEmitter<any>();
  @ViewChild('snackBar', { read: ViewContainerRef }) parent: ViewContainerRef;
  private idEdit: number;
  @Input()
  get editOpen() {
    return this.idEdit;
  }
  set editOpen(value) {
    this.idEdit = value;
    this.editOpenChange.emit(this.idEdit);
  }

  stopTriggerLoss = true;
  stopLimitLoss = true;
  stopTriggerGain = true;
  stopLimitGain = true;
  private _subscription: Subscription;
  data;
  loading = false;
  loadingEditOrder = false;
  indiceFuture = false;
  model: Quote;
  dialog: MatDialog;
  order: SimpleOrder = new SimpleOrder();
  timeInForcesOptions = Constants.TIME_IN_FORCES;
  stopType: string;
  lastTrade;
  minimumIncrement = '0.01';
  tickSize = 2;
  eletronicSignature = this._configService.getEletronicSignatureType();
  loginTypeEnable = this._configService.getLoginTypeEnabled();
  isStop: boolean;
  subscriptionSendOrder: Subscription;
  typesOptions = [
    { id: TypeOrderEnum.LIMITED, text: Constants.TYPE_ORDER_TEXTS.Limited },
    { id: TypeOrderEnum.MARKETPROTECTED, text: Constants.TYPE_ORDER_TEXTS.MarketProtected },
    { id: TypeOrderEnum.MARKET, text: Constants.TYPE_ORDER_TEXTS.Market },
  ];
  priceValuesFormatOptions = Constants.PRICE_VALUES_FORMAT_OPTIONS;
  priceQtdValuesFormatOptions = Constants.QTD_VALUES_FORMAT_OPTIONS;
  advancedOptions = false;
  constructor(
    private _configService: ConfigService,
    private _quoteService: QuoteService,
    private workspaceService: WorkspaceNewService,
    dialog: MatDialog,
    private _authServer: AuthServer,
    private _dailyOrderService: DailyOrderService,
    public _snackBar: CustomSnackbarService,
  ) {
    this.dialog = dialog;
    this.subscriptionSendOrder = this._dailyOrderService.showHiddenPadOrderConfirmation$.subscribe(res => {
      if (res) {
        this.callClose();
        this.loadingEditOrder = false;
      }
    });
  }

  ngOnInit() {
    this.loading = true;
    this.data = this.dataOrder;
    this.order = this._dailyOrderService.convertDailyOrderToSendOrder(this.data);
    this.isStop = this.order.type === TypeOrderEnum.STOP ? true : false;
    this.indiceFuture = this.data.quote.toLowerCase().indexOf('win') === 0 || this.data.quote.toLowerCase().indexOf('wdo') === 0 ||
      this.data.quote.toLowerCase().indexOf('dol') === 0 || this.data.quote.toLowerCase().indexOf('ind') === 0 ? true : false;
    this.priceValuesFormatOptions = !this.indiceFuture ? Constants.PRICE_VALUES_FORMAT_OPTIONS : Constants.PRICE_VALUES_FORMAT_OPTIONS_FUTURES;
    this.priceValuesFormatOptions.align = 'center';

    this._authServer.iQuote.getQuote(this.data.quote)
      .subscribe((x: Quote) => {
        this.order.loteDefault = x.loteDefault;
        this.lastTrade = Number(x.lastTrade);
        this.model = x;
        if (x.tickSize !== undefined && x.tickSize !== null) {
          this.tickSize = x.tickSize;
        }
        if (x.minIntervalIncrPrice !== undefined && x.minIntervalIncrPrice !== null) {
          this.minimumIncrement = `${x.minIntervalIncrPrice}`;
        }
        this.priceValuesFormatOptions.precision = this.tickSize;
        this.loading = false;
      });

    this._quoteService.subscribeQuote(this.data.quote, Constants.WINDOW_NAME_EDIT_ORDER);
    this._subscription = this._quoteService.messagesQuote
      .subscribe((msg) => {
        if (msg && msg.errorMessage && msg.symbol.toLowerCase() === this.data.quote.toLowerCase()) {
          this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), Constants.WINDOW_NAME_EDIT_ORDER);
        } else if (msg !== undefined && msg.symbol != null && msg.symbol.toLowerCase() === this.data.quote.toLowerCase()) {
          let last = msg.lastTrade + '';
          last = last.replace('.', '').replace(',', '.');
          this.lastTrade = Number(last);
          if (msg.minimumIncrement === undefined || !msg.minimumIncrement) {
            this.minimumIncrement = '0.01';
          } else {
            this.minimumIncrement = msg.minimumIncrement.toString().replace(',', '.');
          }
        }
      });
  }

  ngOnDestroy() {
    if (this._subscription) {
      const userWorkspaceSelected: WorkspaceNewDto = this.workspaceService.getUserWorkspaceById(this.workspaceService.getWksSelectedId());
      const userWorkspaces = this.workspaceService.getUserWorkspaces();
      let isExist = false;
      for (let i = 0; i < userWorkspaces.length; i++) {
        if (userWorkspaces[i].Id !== undefined && userWorkspaces[i].Id === userWorkspaceSelected.Id) {
          const workspace = JSON.parse(userWorkspaces[i].JsonData);
          for (let j = 0; j < workspace.content.length; j++) {
            if (workspace.content[j].symbol.toLowerCase() === this.order.quote.toLowerCase()) {
              isExist = true;
              break;
            }
          }
        }
      }
      this._subscription.unsubscribe();
      if (isExist) {
        return;
      } else {
        this._quoteService.unsubscribeQuote(this.order.quote, Constants.WINDOW_NAME_EDIT_ORDER);
      }
    }
    if (this.subscriptionSendOrder) {
      this.subscriptionSendOrder.unsubscribe();
    }
    this.editOpen = -1;
  }

  verifyPrice() {
    return !this.order.type.includes(this.typesOptions[0].id) ? false : true;
  }

  verifyQuantity() {
    this.stopOrderValidator();
  }

  callClose() {
    this.editOpen = -1;
    this.close.emit(true);
  }

  stopOrderValidator() {
    let messageErrorPrice;
    if (this.order.side === Constants.ORDER_SIDE_BUY) {
      if (this.order.stopGain) {
        this.stopTriggerGain = Number(this.order.targettrigger) > Number(this.lastTrade) ? false : true;
        if (!this.stopTriggerGain) {
          messageErrorPrice = Constants.BILLET_ORDER_2_TRIGGER_BUY;
        }
        this.stopLimitGain = Number(this.order.targetlimit) < Number(this.order.targettrigger) ? false : true;
        if (!this.stopLimitGain) {
          messageErrorPrice = Constants.BILLET_ORDER_2_LIMIT_BUY;
        }
      }
      if (this.order.stopLoss) {
        this.stopTriggerLoss = Number(this.order.stoptrigger) < Number(this.lastTrade) ? false : true;
        if (!this.stopTriggerLoss) {
          messageErrorPrice = Constants.BILLET_ORDER_1_TRIGGER_BUY;
        }
        this.stopLimitLoss = Number(this.order.stoplimit) < Number(this.order.stoptrigger) ? false : true;
        if (!this.stopLimitLoss) {
          messageErrorPrice = Constants.BILLET_ORDER_1_LIMIT_BUY;
        }
      }
    } else if (this.order.side === Constants.ORDER_SIDE_SELL) {
      if (this.order.stopGain) {
        this.stopTriggerGain = Number(this.order.targettrigger) < Number(this.lastTrade) ? false : true;
        if (!this.stopTriggerGain) {
          messageErrorPrice = Constants.BILLET_ORDER_2_TRIGGER_SELL;
        }
        this.stopLimitGain = Number(this.order.targetlimit) > Number(this.order.targettrigger) ? false : true;
        if (!this.stopLimitGain) {
          messageErrorPrice = Constants.BILLET_ORDER_2_LIMIT_SELL;
        }
      }
      if (this.order.stopLoss) {
        this.stopTriggerLoss = Number(this.order.stoptrigger) > Number(this.lastTrade) ? false : true;
        if (!this.stopTriggerLoss) {
          messageErrorPrice = Constants.BILLET_ORDER_1_TRIGGER_SELL;
        }
        this.stopLimitLoss = Number(this.order.stoplimit) > Number(this.order.stoptrigger) ? false : true;
        if (!this.stopLimitLoss) {
          messageErrorPrice = Constants.BILLET_ORDER_1_LIMIT_SELL;
        }
      }
    }
    if (messageErrorPrice) {
      this.setSnackBar();
      this._snackBar.createSnack(this.parent, messageErrorPrice, Constants.ALERT_TYPE.info);
      return false;
    }
  }

  confirmationEditModal() {
    this.loadingEditOrder = true;
    if (this.order.loteDefault && this.order.qtd % this.order.loteDefault !== 0) {
      this.loadingEditOrder = false;
      this.callAlert('', Constants.BILLET_ORDER_SEND_11, Constants.ALERT_TYPE.warn);
      return;
    }
    const orderTemp = this.order;
    orderTemp.qtd = Number(this.order.qtd) + (Number(this.data.quantityExecuted) || 0);
    orderTemp.maxfloor = +orderTemp.maxfloor;
    this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.EDIT_ORDER, this.order);
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
  }

  setSnackBar() {
    const element = document.getElementById('snack-bar-msg-edit');
    if (element) {
      element.classList.add('active');
      element.style.visibility = 'visible';
      setTimeout(() => {
        if (element && element.classList.contains('active')) {
          element.classList.remove('active');
        }
      }, 5000);
    }
  }

}
